//src/Components/Buttons/SendButton/index.tsx
import { SendMailIcon } from 'assets/icons';
import Spinner from 'Components/Spinner';
import Tooltip from 'Components/Tooltips';
import { ReactNode } from 'react';

interface SendButtonProps {
  onClick?: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export default function SendButton({
  onClick = () => {},
  onCancel = () => {},
  disabled = false,
  isLoading = false,
}: SendButtonProps) {
  // TODO add disabled variant for textColor
  // tried this textColor: ({ after }) => after(["disabled"]), in tailwing config but not successful

  return disabled ? (
    <button
      disabled={true}
      onClick={onCancel}
      className="px-2 py-1 shadow  flex justify-center  items-center focus:outline-none focus:ring focus:ring-offset-1 text-gray-700  ring-gray-700 rounded hover:text-red-200 "
    >
      {isLoading && <Spinner bounce={false} className="h-5 my-auto" />}

      {!isLoading && <SendMailIcon className="h-5" />}
    </button>
  ) : (
    <Tooltip message={isLoading ? 'Cancel' : 'Send'}>
      <button
        onClick={() => (isLoading ? onCancel() : onClick())}
        className="px-2 py-1 shadow  flex justify-center text-green items-center focus:outline-none focus:ring focus:ring-offset-1 disabled:text-gray-700  focus:ring-green rounded"
      >
        {isLoading && <Spinner bounce={false} className="h-5 my-auto" />}

        {!isLoading && <SendMailIcon className="h-5" />}
      </button>
    </Tooltip>
  );
}
